export default __webpack_public_path__ + "static/SOC-2-renewal-checklist-d0a1ed2b2874dc26ca61e0635e4a0082.jpg";